/* eslint-disable max-len */
import React from 'react';

export default function Filter() {
	return (
		<svg
			width="17"
			height="15"
			viewBox="0 0 17 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="svg filter"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.75 1.5C9.75 0.947715 9.30228 0.5 8.75 0.5C8.19772 0.5 7.75 0.947715 7.75 1.5V5.5H9.75V1.5ZM9.75 13.5V6.5H7.75V13.5C7.75 14.0523 8.19772 14.5 8.75 14.5C9.30228 14.5 9.75 14.0523 9.75 13.5Z"
				fill="white"
			/>
			<path
				d="M10.75 3.5C11.3023 3.5 11.75 3.94772 11.75 4.5C11.75 5.05228 11.3023 5.5 10.75 5.5H6.75C6.19772 5.5 5.75 5.05228 5.75 4.5C5.75 3.94772 6.19772 3.5 6.75 3.5H10.75Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.75 1.5C14.75 0.947715 14.3023 0.5 13.75 0.5C13.1977 0.5 12.75 0.947715 12.75 1.5V10.5H14.75V1.5ZM14.75 13.5V11.5H12.75V13.5C12.75 14.0523 13.1977 14.5 13.75 14.5C14.3023 14.5 14.75 14.0523 14.75 13.5Z"
				fill="white"
			/>
			<path
				d="M15.75 8.5C16.3023 8.5 16.75 8.94772 16.75 9.5C16.75 10.0523 16.3023 10.5 15.75 10.5H11.75C11.1977 10.5 10.75 10.0523 10.75 9.5C10.75 8.94772 11.1977 8.5 11.75 8.5H15.75Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.75 1.5C4.75 0.947715 4.30228 0.5 3.75 0.5C3.19772 0.5 2.75 0.947715 2.75 1.5V11.5H4.75V1.5ZM4.75 13.5V12.5H2.75V13.5C2.75 14.0523 3.19772 14.5 3.75 14.5C4.30228 14.5 4.75 14.0523 4.75 13.5Z"
				fill="white"
			/>
			<path
				d="M1.75 11.5C1.19772 11.5 0.75 11.0523 0.75 10.5C0.75 9.94772 1.19772 9.5 1.75 9.5H5.75C6.30228 9.5 6.75 9.94772 6.75 10.5C6.75 11.0523 6.30228 11.5 5.75 11.5H1.75Z"
				fill="white"
			/>
		</svg>
	);
}
